export default "__VITE_ASSET__DZ$7lv2u__"